const handlePaymentType = (_this, val, stateName) => {
  var values = {
    ..._this.state.values,
    [stateName]: val.toString().split(','),
  }

  if (!val || val?.length === 0) {
    values[stateName] = []
  }

  _this.setState({
    values: values,
  })
}

const handleFocus = (e) => {
  e.target.addEventListener(
    'wheel',
    function (event) {
      event.preventDefault()
    },
    { passive: false }
  )
}

/*
  responseData from catalogue-service has limit of 20
  some offers were created with more than 20 products or categories or brands
  this func ensure that entities are not missing while API cannot fulfil the request size
*/
const constructMissingEntities = (responseData, originalEntityIds, dropIdValue = false) => {
  const responseIds = responseData.flatMap(data => data.id)
  const missedOutIds = originalEntityIds.filter(id => !responseIds.includes(id))
  return [
    ...responseData,
    ...missedOutIds.map(id => ({
      id: id,
      name: dropIdValue ? "id: " : `(id: ${id})`
    }))
  ];
}

export { 
  handlePaymentType, 
  handleFocus,
  constructMissingEntities 
}
